import I18n from 'i18n-js'
import ReactDOM from 'react-dom'
import React from 'react'
import axios from 'axios'

import { Banner, ByPlatformBanner } from 'carpool_shared/components/download_app_banner'

declare let gon: {
  banner_store_ios_url: string
  banner_store_android_url: string
  banner_desktop_url: string

  banner_onboard_url: string
  banner_type?: string
  config: {
    flags: {
      carpool_available_country_codes: string[]
    }
  }
}

const container = document.querySelector('.download-app-banner')
const WEB_BANNER_LOCAL_STORAGE_KEY = 'downloadWebBannerClosedTimestamp'

const showDownloadBanner = async () => {
  if (!container) {
    return
  }
  const body = I18n.t('carpool.download_banner.body_waze')
  const cta = I18n.t('carpool.download_banner.cta_download')

  ReactDOM.render(
    <ByPlatformBanner
      iosBody={body}
      androidBody={body}
      desktopBody={body}
      cta={cta}
      iosLink={gon.banner_store_ios_url}
      androidLink={gon.banner_store_android_url}
      desktopLink={gon.banner_desktop_url}
      localStorageKey={WEB_BANNER_LOCAL_STORAGE_KEY}
      bannerType='download-waze'
    />,
    container
  )
}

const countryAvailable = async () => {
  try {
    const { data } = await axios.get('/web_api/request_info')
    return gon.config.flags.carpool_available_country_codes.indexOf(data.region) >= 0
  } catch {
    return false
  }
}

const showGoToOnboardBanner = async (checkCountry: boolean) => {
  if (container && (!checkCountry || (await countryAvailable()))) {
    const body = I18n.t('carpool.download_banner.body_general')
    const cta = I18n.t('carpool.download_banner.cta_try_now')

    ReactDOM.render(
      <Banner
        body={body}
        cta={cta}
        link={gon.banner_onboard_url}
        localStorageKey={WEB_BANNER_LOCAL_STORAGE_KEY}
        bannerType='onboard'
      />,
      container
    )
  }
}

if (gon.banner_type === 'onboard') {
  showGoToOnboardBanner(true)
} else {
  showDownloadBanner()
}
